import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { uploadData } from '../../utils/helper.js';
import './UpdateForm.scss';

function UpdateForm() {
    const [updateData, setUpdateData] = React.useState({})
    const [validationError, setValidationError] = React.useState({});

    console.log('data', updateData)
    console.log('errors', validationError)

    const onChangeErrorSetter = (name, msg) => {
        let error = validationError;
        delete error[name];
        console.log({ ...error, [name]: msg });
        setValidationError({ ...error, [name]: msg });
        return;
      };
    

    const handleChange = (e) => {
        let { name, value } = e.target

        let error = validationError;
        delete error[name];

        if (name === "userName") {
        if (value == null || value === "") {
            onChangeErrorSetter(name, "This Field cannot be Empty");
        } 
        }

        if (name === "password") {
        if (value == null || value === "") {
            onChangeErrorSetter(name, "This Field cannot be Empty");
        }
        }

        if (name === "content") {
            if (value == null || value === "") {
            onChangeErrorSetter(name, "This Field cannot be Empty");
            }
        }
         
        setUpdateData({...updateData, [name]: value});
    }

    const handleClick = (e) => {
        e.preventDefault();
        const { userName, password, content } = updateData;
        const err1 = {};
        const err2 = {};
        const err3 = {};
    
        if (!userName || !password || !content) {
          if (!userName) {
            err1["userName"] = "This field is required";
          }
    
          if (!password) {
            err2["password"] = "This field is required";
          }

          if (!content) {
            err3["content"] = "This field is required";
          }
          const finalObj = Object.assign(err1, err2, err3);
          setValidationError(finalObj);
          return;
        }
    
        // Api end point call here
        console.log("API CALLED");

        uploadData(updateData)
        
      };

    return (
        <div>
            <div className="container upd-form-cont-div">
                <Form className="upd-form">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>User Name</Form.Label>
                        <Form.Control 
                            type="text" 
                            name="userName" 
                            onChange={handleChange} 
                            placeholder="User Name" 
                        />
                        {
                            validationError.userName && <p className="val-errors">{validationError.userName}</p>
                        }
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Password</Form.Label>
                        <Form.Control 
                            type="text"
                            name="password" 
                            onChange={handleChange}
                            placeholder="Password" 
                        />
                        {
                            validationError.password && <p className="val-errors">{validationError.password}</p>
                        }
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Content</Form.Label>
                        <Form.Control 
                            as="textarea"
                            name="content" 
                            onChange={handleChange}
                            rows={5} 
                            placeholder="Content" 
                        />
                        {
                            validationError.content && <p className="val-errors">{validationError.content}</p>
                        }
                    </Form.Group>
                    <Button className="primary form-control" onClick={handleClick}>Submit</Button>
                </Form>
            </div>
        </div>
    )
}

export default UpdateForm